// extracted by mini-css-extract-plugin
export default {"container":"mXZx3","buttonLayout":"MLnpY","textLayout":"_6ibP0"};